var React = require('react');

function CloseAlizarinCrimson (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-0.610474","x2":"13.7542","y2":"-0.610474","transform":"matrix(0.72705 0.686585 -0.72705 0.686585 0 1.55664)","stroke":"#E3232A","strokeWidth":"1.22095","key":0}),React.createElement("line",{"y1":"-0.610474","x2":"13.7542","y2":"-0.610474","transform":"matrix(-0.72705 0.686585 -0.72705 -0.686585 10 1)","stroke":"#E3232A","strokeWidth":"1.22095","key":1})]);
}

CloseAlizarinCrimson.defaultProps = {"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none"};

module.exports = CloseAlizarinCrimson;

CloseAlizarinCrimson.default = CloseAlizarinCrimson;
